__turbopack_context__.v({
  "copy": "TeaserSocial-module-scss-module__S5wSrG__copy",
  "desktopPostings": "TeaserSocial-module-scss-module__S5wSrG__desktopPostings",
  "desktopPostingsList": "TeaserSocial-module-scss-module__S5wSrG__desktopPostingsList",
  "mobileMdSlider": "TeaserSocial-module-scss-module__S5wSrG__mobileMdSlider",
  "mobileSliderWrapper": "TeaserSocial-module-scss-module__S5wSrG__mobileSliderWrapper",
  "mobileSmSlider": "TeaserSocial-module-scss-module__S5wSrG__mobileSmSlider",
  "postingImage": "TeaserSocial-module-scss-module__S5wSrG__postingImage",
  "rotateLeft": "TeaserSocial-module-scss-module__S5wSrG__rotateLeft",
  "rotateRight": "TeaserSocial-module-scss-module__S5wSrG__rotateRight",
  "swiperFull": "TeaserSocial-module-scss-module__S5wSrG__swiperFull",
  "swiperSlide": "TeaserSocial-module-scss-module__S5wSrG__swiperSlide",
  "title": "TeaserSocial-module-scss-module__S5wSrG__title",
  "titleRow": "TeaserSocial-module-scss-module__S5wSrG__titleRow",
  "wrapper": "TeaserSocial-module-scss-module__S5wSrG__wrapper",
});
